import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { watchHistorySelector as stateSelector } from 'reduxModules/auth/selectors'
import { watchHistoryDispatcher as dispatchSelector } from 'reduxModules/auth/dispatchers'
import LoadingComponent from 'components/generic/LoadingComponent'
import HistoryItem from './HistoryItem'

import './styles.css'

export function WatchHistory({
  currentlyWatching = { results: [], count: 0 },
  isLoading = 0,
  ...props
}) {
  useEffect(() => {
    props.loadWatchHistory()
  }, [])

  const results = currentlyWatching?.results || []
  const count = currentlyWatching?.count || 0
  const hasMore = results.length < count
  const initialLoading = !!isLoading && results.length === 0
  const loadingMore = !!isLoading && results.length > 0

  return (
    <div id="WatchHistory" className="account-section">
      <h3 className="account-section__title">Watch History</h3>

      {initialLoading && <LoadingComponent />}

      {!initialLoading && results.length === 0 && (
        <div className="no-results">
          <svg
            className="no-results__icon"
            viewBox="0 0 24 24"
            width="56"
            height="56"
            aria-hidden="true"
          >
            <path
              fill="currentColor"
              d="M12 5a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7V3l4 4-4 4V5Zm-1 4h2v4.4l3 1.8-1 1.7-4-2.4V9Z"
            />
          </svg>
          <span>
            You haven&apos;t watched any videos yet. Start a course and it&apos;ll
            show up here so you can pick up where you left off.
          </span>
        </div>
      )}

      {results.length > 0 && (
        <>
          <div className="history-list">
            {results.map((bookmark) => (
              <HistoryItem
                key={bookmark?.tutorial?.id}
                slug={bookmark?.tutorial?.slug}
                title={bookmark?.tutorial?.title}
                teacher={bookmark?.tutorial?.artist?.title}
                teacherSlug={bookmark?.tutorial?.artist?.slug}
                thumb={bookmark?.tutorial?.photo?.boxThumb}
                summary={bookmark?.tutorial?.description}
                progress={bookmark?.pctgWatched}
                completed={bookmark?.pctgCompleted >= 99}
              />
            ))}
          </div>

          <div className="history-list__footer">
            <span className="history-list__count">
              Showing {results.length} of {count}
            </span>
            {hasMore && (
              <button
                type="button"
                className="btn -mini -border-white"
                disabled={loadingMore}
                onClick={() => props.loadMoreWatchHistory(results.length)}
              >
                {loadingMore ? 'Loading…' : 'Load More'}
              </button>
            )}
          </div>
        </>
      )}
    </div>
  )
}

WatchHistory.propTypes = {
  loadWatchHistory: PropTypes.func.isRequired,
  loadMoreWatchHistory: PropTypes.func.isRequired,
  currentlyWatching: PropTypes.shape({
    results: PropTypes.array,
    count: PropTypes.number
  }),
  isLoading: PropTypes.number
}

export default connect(stateSelector, dispatchSelector)(WatchHistory)
